import { render, staticRenderFns } from "./side_menu.vue?vue&type=template&id=184d365a&scoped=true&"
import script from "./side_menu.vue?vue&type=script&lang=js&"
export * from "./side_menu.vue?vue&type=script&lang=js&"
import style0 from "./side_menu.vue?vue&type=style&index=0&id=184d365a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184d365a",
  null
  
)

export default component.exports